<!--
 * @Author       : Archer<ahh666@qq.com>
 * @Date         : 2023-10-10 22:24:24
 * @LastEditors  : Archer<ahh666@qq.com>
 * @LastEditTime : 2023-10-12 02:05:11
 * @FilePath     : \youxi\youxi\src\views\PersonalCenter\Reward\index.vue
 * @Description  : Description
-->
<template>
  <div id="coupon">
    <div v-if="!showDetail">
      <div class="tabbar">
        <div
          :class="item === currentChoose ? 'isAcitve' : ''"
          v-for="(item, index) in currentTabbar"
          :key="index"
          @click="clickItem(item, index)"
        >
          {{ item }}
        </div>
        <span
          class="view-dead-coupon"
          v-if="this.currentChooseValid === '虚拟奖品'"
          ><span @click="tabBtn" class="jump"> {{ tabBtnText }} > </span></span
        >
      </div>
      <div
        class="coupon_list"
        v-if="totalCount !== 0 || currentRewardType !== '虚拟奖品'"
      >
        <div class="content" v-if="this.currentChooseValid === '虚拟奖品'">
          <div
            :class="[
              'coupon_list_item',
              'coupon_list_item--coupon',
              isValid ? '' : 'coupon_list_item--invalid'
            ]"
            v-for="(item, index) in tableData"
            :key="index"
          >
            <div class="left">
              <span class="amount"
                ><span class="icon">¥</span>{{ item.amount }}</span
              >
              <span class="limit">满{{ item.threshold }}元可用</span>
            </div>
            <div class="middle">
              <span class="name">{{ item.coupon_name }}</span>
              <span class="time">{{ item.validate_stop_time }} 到期</span>
              <span class="use-range"
                >{{ item.use_range
                }}<span
                  @mouseleave="chooseId = ''"
                  @mouseenter="showInstructions(item)"
                  class="instructions"
                  >使用说明
                  <img
                    src="@/assets/image/Coupon/blackArrow.png"
                    alt=""
                  />
                  <span class="dialog" v-if="item.id == chooseId">
                    <h3>使用说明：</h3>
                    {{ item.coupon_desc }}
                  </span></span
                ></span
              >
            </div>
            <div class="right" @click="useNow(item)">
              <span v-if="isValid" class="use-now">立即使用</span>
              <span
                v-else
                :class="[
                  'has-use',
                  currentChooseInvalid == '已使用' ? 'used' : 'expired'
                ]"
              ></span>
            </div>
          </div>
        </div>
        <div class="content" v-else>
          <div
            :class="[
              'coupon_list_item',
              'coupon_list_item--goods',
              item.status === 0 ? '' : 'coupon_list_item--invalid'
            ]"
            v-for="(item, index) in tableData"
            :key="index"
          >
            <div class="left">
              <img class="sw-img" :src="item.prize_img" />
            </div>
            <div class="sw-desc">
              <div class="sw-name">{{ item.prize_name }}</div>
              <div class="sw-price">价值：{{ item.prize_price }}元</div>
              <div class="sw-sum">数量：X1</div>
            </div>
            <div class="right" @click="useNow(item)">
              <span v-if="item.status === 0" class="use-now">立即领取</span>
              <span v-else :class="['has-use', 'used-had']"></span>
            </div>
          </div>
        </div>
        <div
          class="pages"
          v-if="totalCount !== 0 && currentRewardType === '虚拟奖品'"
        >
          <common-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="pages"
            :page-size="PageSize"
            layout="prev, pager, next, jumper"
            :total="totalCount"
          >
          </common-pagination>
        </div>
        <div></div>
      </div>
      <div class="coupon_list no_data" v-else>
        <empty-state
          :title="isValid ? '暂无可用奖品' : '暂无失效奖品'"
          description="活动奖品会根据奖品类型和领取状态自动归类展示"
          icon="el-icon-present"
          :icon-size="52">
        </empty-state>
      </div>
    </div>
    <!-- 收货地址dialog -->
    <div class="ship-addr-dialog" v-if="showShipAddrDialog">
      <div class="dialog-main">
        <img
          class="dialog-close"
          @click="showShipAddrDialog = false"
          src="../../XXHavingYou/img/dialog-close-3.png"
        />
        <div class="dialog-title">填写收货地址</div>
        <div class="ship-addr-body">
          <div class="form-item">
            <span class="label">收货人</span>
            <el-input
              v-model="shipAddrForm.name"
              placeholder="请填写收货人的姓名"
            ></el-input>
          </div>
          <div class="form-item">
            <span class="label">手机号码</span>
            <el-input
              v-model="shipAddrForm.telephone"
              placeholder="请填写收货人的手机号"
            ></el-input>
          </div>
          <div class="form-item">
            <span class="label">省市区</span>
            <el-cascader
              placeholder="请选择省市区"
              v-model="shipAddrForm.area"
              :options="ChinaAddressArea"
              :props="{
                label: 'name'
              }"
              @change="handleAddressChange"
            ></el-cascader>
          </div>
          <div class="form-item">
            <span class="label">详细地址</span>
            <el-input
              v-model="shipAddrForm.address"
              type="textarea"
              placeholder="请输入地址"
              maxlength="30"
              show-word-limit
            ></el-input>
          </div>
          <div class="btn-group">
            <div class="btn-cancel" @click="showShipAddrDialog = false">
              取消
            </div>
            <div
              class="btn-save"
              :class="{ 'btn-save-disabled': !canClickSaveShipAddr }"
              @click="saveShipAddr"
            >
              保存并领取
            </div>
          </div>
          <div class="ship-addr-tip">
            <img src="../../XXHavingYou/img/tip-icon.png" />
            因涉及到实物寄送，请确保填写的信息正确，如有问题请联系客服
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { couponPrizeListApi, underPrizeListApi } from "@/request/API";
import { underPrizeReceiveApi } from "../../XXHavingYou/api";
import { addressArea } from "../../Contract/newMap";
import CommonPagination from "@/components/commonPagination";
import EmptyState from "@/components/emptyState";
export default {
  name: "",
  props: {},
  components: {
    CommonPagination,
    EmptyState
  },
  data() {
    return {
      ChinaAddressArea: [],
      shipAddrForm: {
        name: "",
        telephone: "",
        area: [],
        address: ""
      },
      chooseId: "",
      showDetail: false,
      totalCount: 0,
      PageSize: 10,
      prize_info: {},
      showShipAddrDialog: false,
      isValid: true,
      currentRewardType: 1,
      currentChooseInvalid: "已使用",
      currentChooseValid: "虚拟奖品",
      tabbarItemValid: ["虚拟奖品", "实物奖品"],
      tabbarItemInvalid: ["已使用", "已过期"],
      tableData: [],
      pages: 1,
      coupon_type: 1,
      assess_price: "",
      product_id: "",
      game_id: ""
    };
  },
  methods: {
    handleAddressChange(v) {},
    clickItem(item, index) {
      this.pages = 1;
      if (this.isValid) {
        this.currentChooseValid = item;
      } else {
        this.currentChooseInvalid = item;
      }
      this.getData();
    },
    useNow(item) {
      if (this.isValid) {
        if (this.currentChoose == "虚拟奖品") {
          if (item.use_range == "全部游戏账号可用") {
            this.$router.push({ name: "AllGame", params: {} });
          } else {
            this.$router.push({
              name: "AllGame",
              params: { coupon: true, coupon_id: item.coupon_id }
            });
          }
        } else {
          this.prize_info = item;
          this.showShipAddrDialog = true;
        }
      }
    },
    //分页监听事件
    handleCurrentChange(val) {
      console.log(val, "pageee");
      this.getData();
    },
    tabBtn() {
      this.pages = 1;
      this.isValid = !this.isValid;
      this.getData();
    },
    saveShipAddr() {
      if (!this.canClickSaveShipAddr) {
        return;
      }
      underPrizeReceiveApi({
        activity_id: 0,
        lottery_id: this.prize_info?.id,
        name: this.shipAddrForm.name,
        telephone: this.shipAddrForm.name,
        address: this.shipAddrForm.area.join("") + this.shipAddrForm.address
      }).then(res => {
        this.$message({
          type: "success",
          center: true,
          message:
            "奖品领取成功，7-10个工作日会寄出，若有问题请咨询活动页面客服"
        });
        this.getData();
        this.showShipAddrDialog = false;
      });
    },
    showInstructions(item) {
      if (this.isValid) {
        this.chooseId = item.id;
      }
    },
    getData() {
      this.tableData = [];
      let params = { pageSize: 10, page: this.pages, status: 0 };
      if (this.isValid) {
        params.status = 0;
        this.currentRewardType = this.currentChoose;
      } else {
        params.status = this.currentChooseInvalid == "已使用" ? 1 : 2;
      }
      (this.currentRewardType === "虚拟奖品"
        ? couponPrizeListApi
        : underPrizeListApi)({
        ...params,
        activity_id: 0
      }).then(res => {
        let list =
          this.currentRewardType === "虚拟奖品" ? res.data.list : res.data;
        this.tableData = list.map(item => {
          switch (item.use_range) {
            case 1:
              item.use_range = "全部游戏账号可用";
              break;
            case 2:
              item.use_range = "部分游戏账号可用";
              break;
            case 3:
              item.use_range = "部分账号商品可用";
              break;
            default:
              break;
          }
          return item;
        });
        this.totalCount = res.data.total; //tab切换后的数据并不是接口请求回来的总数
      });
    }
  },
  mounted() {
    if(localStorage.getItem('rewardType') === '实物奖品') {
      this.currentChooseValid = '实物奖品'
      localStorage.removeItem('rewardType')
    }
    this.urlParams = this.$route.query;
    this.ChinaAddressArea = addressArea;
    this.getData();
  },
  watch: {},
  computed: {
    canClickSaveShipAddr() {
      return Object.values(this.shipAddrForm).every(
        item => item && item.length > 0
      );
    },
    currentTabbar() {
      return this.isValid ? this.tabbarItemValid : this.tabbarItemInvalid;
    },
    tabBtnText() {
      return this.isValid ? "查看失效券" : "返回";
    },
    currentChoose() {
      return this.isValid ? this.currentChooseValid : this.currentChooseInvalid;
    }
  }
};
</script>
<style lang="less">
#per_center .main:has(#coupon) {
  overflow: visible;
}
</style>
<style lang="less" scoped>
#coupon {
  padding: 20px;
  display: flex;
  flex-direction: column;
  color: var(--text-main, #111827);

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  .tabbar {
    min-height: 40px;
    height: auto;
    margin: 0 0 18px;
    padding: 4px 0 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;

    div {
      height: 34px;
      padding: 0 16px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: var(--text-secondary, #5A5F6B);
      line-height: 20px;
      cursor: pointer;
      user-select: none;
      transition: color .2s ease, background .2s ease, box-shadow .2s ease;

      &:hover {
        color: var(--text-main, #1A1D24);
        background: var(--bg-tag, #F0EDE8);
      }
    }

    .isAcitve {
      position: relative;
      color: #FFFFFF;
      background: var(--bg-dark, #1A1D24);
      box-shadow: 0 8px 18px rgba(26, 29, 36, 0.18);
      font-weight: 500;

      &:hover {
        color: #FFFFFF;
        background: var(--bg-dark, #1A1D24);
        box-shadow: 0 8px 18px rgba(26, 29, 36, 0.18);
      }
    }

    .view-dead-coupon {
      flex: 1;
      min-width: 120px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: var(--text-main, #1A1D24);
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .jump {
        height: 34px;
        padding: 0 14px;
        border-radius: 4px;
        display: inline-flex;
        align-items: center;
        background: var(--bg-tag, #F0EDE8);
        cursor: pointer;
        user-select: none;
        transition: color .2s ease, background .2s ease;

        &:hover {
          color: #FFFFFF;
          background: var(--bg-dark, #1A1D24);
        }
      }
    }
  }

  .coupon_list {
    min-height: 620px;
    padding: 16px;
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    background: var(--bg-card, #FFFFFF);

    .content {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 16px;

      .coupon_list_item {
        min-width: 0;
        min-height: 132px;
        border-radius: 4px;
        display: flex;
        border: 1px solid rgba(255, 90, 31, 0.18);
        background: linear-gradient(90deg, var(--primary-soft, #FCEDE5) 0, #FFFFFF 128px, #FFFFFF 100%);
        box-shadow: 0 8px 24px rgba(255, 122, 26, 0.08);
        justify-content: space-between;
        align-items: center;
        position: relative;
        overflow: visible;
        transition: border-color .2s ease, box-shadow .2s ease;

        &:hover {
          border-color: rgba(255, 90, 31, 0.38);
          box-shadow: 0 12px 28px rgba(255, 90, 31, 0.14);
          z-index: 20;
        }

        &::before {
          width: 4px;
          align-self: stretch;
          border-radius: 4px 0 0 4px;
          background: var(--primary, #FF5A1F);
          content: "";
        }

        &--goods {
          border-color: var(--border-soft, #E8E4DE);
          background: linear-gradient(90deg, var(--bg-tag, #F0EDE8) 0, #FFFFFF 128px, #FFFFFF 100%);
          box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

          &::before {
            background: var(--bg-dark, #1A1D24);
          }

          &:hover {
            border-color: rgba(26, 29, 36, 0.26);
            box-shadow: 0 12px 28px rgba(26, 29, 36, 0.12);
          }

          .left {
            border-right-color: var(--border-soft, #E8E4DE);
          }

          .right .use-now {
            color: var(--text-main, #1A1D24);
            background: var(--bg-tag, #F0EDE8);

            &:hover {
              color: #FFFFFF;
              background: var(--bg-dark, #1A1D24);
              box-shadow: 0 8px 18px rgba(26, 29, 36, 0.18);
            }
          }
        }

        &--invalid {
          background: var(--bg-tag, #F0EDE8);
          border-color: var(--border-soft, #E8E4DE);
          box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

          &::before {
            background: var(--border-strong, #D8D2CA);
          }

          .left .amount,
          .middle .name,
          .sw-name {
            color: var(--text-muted, #9AA0AC);
          }

          .left {
            border-right-color: var(--border-soft, #E8E4DE);
          }

          .sw-img {
            filter: grayscale(1);
          }

          &:hover {
            border-color: var(--border-strong, #CBD5E1);
            box-shadow: 0 12px 28px rgba(26, 29, 36, 0.1);
          }
        }

        .left {
          flex: 0 0 112px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          min-height: 100px;
          padding: 0 18px;
          border-right: 1px dashed rgba(255, 122, 26, 0.26);

          .amount {
            max-width: 100%;
            font-size: 32px;
            color: var(--primary, #FF7A1A);
            font-weight: 600;
            line-height: 38px;
            white-space: nowrap;

            .icon {
              margin-right: 2px;
              font-size: 14px;
              font-weight: 500;
            }
          }

          .limit {
            max-width: 100%;
            margin-top: 4px;
            color: var(--text-muted, #9AA0AC);
            font-size: 12px;
            line-height: 18px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .sw-img {
            width: 72px;
            height: 72px;
            display: block;
            object-fit: contain;
            transition: filter .2s ease, transform .2s ease;
          }
        }

        .middle {
          flex: 1;
          min-width: 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          padding: 18px 14px 18px 18px;

          .name {
            width: 100%;
            font-size: 16px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 600;
            color: var(--text-main, #111827);
            line-height: 22px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .time {
            padding: 8px 0;
            font-size: 12px;
            color: var(--text-secondary, #5A5F6B);
            font-weight: 400;
            line-height: 18px;
          }

          .use-range {
            max-width: 100%;
            display: flex;
            align-items: center;
            color: var(--text-muted, #9AA0AC);
            font-size: 12px;
            line-height: 18px;

            .instructions {
              flex: 0 0 auto;
              color: var(--primary, #FF7A1A);
              margin-left: 12px;
              user-select: none;
              position: relative;
              display: inline-flex;
              align-items: center;
              cursor: default;
              z-index: 30;

              &::after {
                position: absolute;
                top: 18px;
                left: 0;
                width: 280px;
                height: 12px;
                content: "";
              }

              img {
                width: 8px;
                margin-left: 4px;
                opacity: .45;
              }

              .dialog {
                h3 {
                  margin: 0 0 6px 0;
                  font-size: 14px;
                  line-height: 20px;
                  color: var(--primary, #FF7A1A);
                }

                position: absolute;
                background: var(--bg-card, #FFFFFF);
                z-index: 60;
                top: 24px;
                left: 0;
                border-radius: 4px;
                padding: 12px 14px;
                width: 280px;
                border: 1px solid rgba(255, 90, 31, 0.18);
                box-shadow: 0 12px 28px rgba(255, 90, 31, 0.14);
                color: var(--text-secondary, #5A5F6B);
                font-size: 13px;
                font-weight: 400;
                line-height: 21px;
              }
            }
          }
        }

        .sw-desc {
          flex: 1;
          min-width: 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          padding: 18px 14px 18px 18px;

          .sw-name {
            width: 100%;
            font-size: 16px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 600;
            color: var(--text-main, #111827);
            line-height: 22px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .sw-price {
            padding: 8px 0 6px;
            font-size: 13px;
            line-height: 18px;
            color: var(--primary, #FF5A1F);
          }

          .sw-sum {
            min-width: 52px;
            height: 22px;
            padding: 0 8px;
            border-radius: 4px;
            background: var(--bg-tag, #F0EDE8);
            font-size: 12px;
            line-height: 22px;
            color: var(--text-muted, #9AA0AC);
          }
        }

        .right {
          flex: 0 0 100px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          min-height: 100px;
          padding-right: 18px;

          .use-now {
            min-width: 76px;
            height: 32px;
            border-radius: 4px;
            border: none;
            background: var(--primary-soft, #FCEDE5);
            font-size: 12px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 500;
            color: var(--primary, #FF5A1F);
            line-height: 32px;
            text-align: center;
            cursor: pointer;
            user-select: none;
            transition: color .2s ease, background .2s ease, box-shadow .2s ease;

            &:hover {
              color: #FFFFFF;
              background: var(--primary, #FF5A1F);
              box-shadow: 0 8px 18px rgba(255, 90, 31, 0.18);
            }
          }

          .has-use {
            width: 76px;
            height: 64px;
            opacity: .75;
          }

          .used {
            background: url("../../../assets/image/Coupon/hasUse.png");
            background-size: cover;
          }

          .used-had {
            background: url("../../XXHavingYou/img/usenow.png");
            background-size: cover;
          }

          .expired {
            background: url("../../../assets/image/Coupon/expired.png");
            background-size: cover;
          }
        }
      }
    }

    .pages {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .no_data {
    min-height: 520px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media (max-width: 960px) {
    .coupon_list .content {
      grid-template-columns: 1fr;
    }
  }
}

.ship-addr-dialog {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 199;
  padding: 24px;
  background: rgba(15, 23, 42, 0.46);

  .dialog-main {
    width: 440px;
    max-width: 100%;
    min-height: 500px;
    padding: 24px;
    background: var(--bg-card, #FFFFFF);
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    position: relative;
    box-shadow: 0 20px 48px rgba(15, 23, 42, 0.18);
    font-size: 16px;
    font-weight: 500;
    color: var(--text-main, #111827);
  }

  .dialog-close {
    width: 30px;
    height: 30px;
    cursor: pointer;
    position: absolute;
    right: 18px;
    top: 18px;
    z-index: 29;
    border-radius: 50%;
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.14);
  }

  .dialog-title {
    padding-right: 40px;
    font-size: 18px;
    line-height: 26px;
    font-weight: 600;
    color: var(--text-main, #111827);
  }

  .ship-addr-body {
    padding-top: 18px;

    .form-item {
      color: var(--text-main, #111827);
      font-size: 14px;
      display: flex;
      align-items: flex-start;
      margin-top: 16px;

      .label {
        flex: 0 0 78px;
        padding-top: 9px;
        text-align: left;
        color: var(--text-secondary, #5A5F6B);
        line-height: 20px;
      }

      .el-input,
      .el-textarea,
      .el-cascader {
        flex: 1;
        width: auto;
      }

      /deep/.el-input__inner,
      /deep/.el-textarea__inner {
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 4px;
        background: var(--bg-tag, #F0EDE8);
        color: var(--text-main, #111827);
        transition: border-color .2s ease, background .2s ease;

        &:focus {
          border-color: var(--primary, #FF5A1F);
          background: var(--bg-card, #FFFFFF);
        }
      }

      /deep/.el-textarea__inner {
        min-height: 86px !important;
      }

      /deep/.el-input__count {
        background: transparent;
        color: var(--text-muted, #9AA0AC);
      }

      /deep/.el-input__count-inner {
        background: transparent;
      }
    }

    .btn-group {
      display: flex;
      justify-content: flex-end;
      gap: 12px;
      margin: 24px 0 0;
      text-align: center;

      .btn-cancel,
      .btn-save {
        cursor: pointer;
        min-width: 116px;
        height: 38px;
        border-radius: 4px;
        font-size: 14px;
        line-height: 38px;
        user-select: none;
        transition: color .2s ease, background .2s ease, border-color .2s ease, box-shadow .2s ease, opacity .2s ease;
      }

      .btn-cancel {
        border: 1.5px solid var(--bg-dark, #1A1D24);
        color: var(--text-main, #1A1D24);
        background: #FFFFFF;

        &:hover {
          color: var(--text-main, #1A1D24);
          border-color: var(--bg-dark, #1A1D24);
          background: var(--bg-tag, #F0EDE8);
        }
      }

      .btn-save {
        background: var(--primary, #FF5A1F);
        border: 1px solid transparent;
        color: #FFFFFF;
        box-shadow: 0 8px 18px rgba(255, 90, 31, 0.18);

        &:hover {
          background: var(--primary-hover, #E84A12);
          box-shadow: 0 10px 22px rgba(255, 90, 31, 0.22);
        }

        &-disabled {
          opacity: 0.45;
          cursor: not-allowed;
          box-shadow: none;
        }
      }
    }

    .ship-addr-tip {
      display: flex;
      align-items: flex-start;
      gap: 6px;
      margin: 18px 0 0;
      padding: 10px 12px;
      border-radius: 4px;
      background: var(--primary-soft, #FCEDE5);
      font-size: 12px;
      line-height: 18px;
      color: var(--text-secondary, #5A5F6B);

      img {
        flex: 0 0 auto;
        width: 12px;
        height: 12px;
        position: relative;
        top: 3px;
      }
    }
  }
}
</style>
